export default __webpack_public_path__ + "static/media/173.fdbd3e57.png";